/**
 * 将从主应用传递的rootProps中暴露的方法加以保存使用
 * 也可以保存至react的context上，但仅能在组件中使用，一些无组件的场景无法满足
 *
 * TODO: 尝试更优雅的方式
 */
 let rootProps: any = {};

 function setRootProps(source: any) {
   rootProps = source;
 }
 
 function getRootProps() {
   return rootProps;
 }
 
 export { setRootProps, getRootProps };